import React, { useCallback } from "react";
import Container from "./style";

function Terms() {

const termsInfo=[
	{
		header:"Introduction",
		content:[]
	},
	{
		title:"Our Agreement with you is made up of:",
		content:[]
	},
	{
		title:"these general terms and conditions (General Terms);",
		content:[]
	},
	{
		title:"the Additional Term(s) applicable to the Products we are providing to you including the User Guide(s) applicable to the Products we are providing to you (you can find URL’s to the User Guides in Part C of Appendix B)",
		content:[]
	},
	{
		title:`the Price Confirmation Letter (if any),which together explain our duties to each other and makes up the full understanding between us for
		each Product we agree to provide you with in connection with your account with us.`,
		content:[]
	},

	{
		title:`Appendix A sets out the meaning of the capitalised terms used in this Agreement. Appendix B sets out the Products this Agreement applies to (together with the relevant Specific Terms). Appendix C
		sets out a compensation matrix detailing compensation which may be available for certain Products.`,
		content:[]
	},

	{
		title:`This Agreement constitutes the entire agreement between us with respect to the subject matter
		of
		this Agreement and (to the extent permissible by law) supersedes all prior representations or oral or
		written agreements between us and you. We agree that neither of us has been induced to enter into
		this Agreement by any statement or representation not expressly documented within it.`,
		content:[]
	},

	{
		title:`Except for clauses 2.5, 14.6 and 14.13 which shall always take precedence over any other term in
		this
		Agreement, if any of the Additional Terms contradict any of the General Terms, the term in the
		Additional Terms take precedence to the extent of that contradiction. If a term in a User Guide
		contradicts any other term in the Additional Terms, the term in the User Guide take precedence to
		the
		extent of that contradiction.`,
		content:[]
	},

	{
		title:`Unless otherwise specified, a reference to a statutory provision or to a URL is a reference to that
		provision or URL as amended from time to time (whether before or after the start of this
		Agreement)`,
		content:[]
	},

	{
		header:"Providing the Products",
		content:[]
	},
	{
		title:`We will provide you with Products (and any other services as set out in this Agreement) on all
		Working
		Days (unless we notify you otherwise via our website (www.astar.ng or substitute URL) or in
		accordance with Clause 19.2).`,
		content:[]
	},
	{
		title:`We will receive your Items when you give us (and when we sign, if this applies) the relevant
		documentation described in clauses 3.6 to 3.10, or any other document that you need to provide for
		the Products at Handover. We will accept the Items once we are satisfied that the Posting and the
		documentation that comes with it are accurate and meet the terms of this Agreement. However, it is
		always your responsibility (and not ours) to ensure that the documentation meets the requirements
		
		of this Agreement and relevant Law. Any responsibility we may have to you for loss or damage starts
		when we receive your Items.`,
		content:[]
	},
	{
		title:`If we have agreed to collect Items from you, we will collect each Posting from the Handover
		Point at
		the times confirmed with you, using our standard operating procedures.`,
		content:[]
	},
	{
		header:`Classified: RMG – Internal`,
		content:[]
	},
	{
		title:`We may not collect, process or deliver any Items if we consider it to be impractical or
		unreasonable
		to do so, including if:`,
		content:[]
	},
	{
		title:`the address is not safe or our staff&#39;s health and safety would be at risk in any way;`,
		content:[]
	},{
		title:`there is no-one living permanently at the address we have to deliver the Item to;`,
		content:[]
	},{
		title:`the address on the Item is incomplete or has not been written or printed clearly enough to
		read;`,
		content:[]
	},{
		title:`we need a signature for any Item we deliver and nobody is available to sign;`,
		content:[]
	}
	,{
		title:`the Regulator has required us to do or not do something, and as a consequence we are unable
		to collect, process or deliver the Item;`,
		content:[]
	},
	{
		title:"you have not confirmed the Handover Point with us; or",
		content:[]
	},
	{
		title:`to do so would not be in accordance with this Agreement (for example, the Item contains
			Prohibited Materials).`,
		content:[]
	},
	{
		title:`Notwithstanding any other provision of this Agreement (including without limitation and for the
			avoidance of doubt, in any of the Additional Terms, Rate Cards and Price Confirmation Letters), in
			exceptional circumstances, and/or where, in our reasonable opinion, there is a material risk to the
			health and safety of our staff, our customers or Intended Recipients, we may do one or more of the
			following, provided at all times our actions are reasonable in the circumstances:`,
		content:[]
	},
	{
		title:"change how and when we collect, process or deliver any Items;",
		content:[]
	},
	{
		title:`suspend or change any Products or services, including guaranteed or target delivery times and
		service levels;`,
		content:[]
	},{
		title:`suspend or change the terms that apply to claims, including the payment of refunds or
		compensation and the claims’ timescales and processes; and/or`,
		content:[]
	},{
		title:`change our prices to reflect the effect of the exceptional circumstances and/or the health and
		safety issues on our costs.
		(each a Change). We will publish information relating to any such Change on our website as soon
		as practical and the Change will take effect at the date specified.`,
		content:[]
	},
]


function number(id) {
   if(9>id){
      if(0!= id){
      return `${id}.`
	  }
   } else  if(13>id){
	if(9!= id){
	return `${id-9}.`
	}
 }else  if(27>id){
	if(13!= id){
	return `${id-13}.`
	}
 }
}


  return (
    <Container>
      <div className="Container">
        <div className="SectionParagraph"></div>

        <h1 className="Header">Terms and conditions</h1>
        <div className="LastUpdated">
          <h3> Who this Agreement applies to</h3>
          <div style={{ marginLeft: 40 , color:"#fff"}}>
            <div style={{ marginBottom: 10 }}>
              A. astar.ng Limited, a company incorporated Nigeria (number
              802415) with its registered address at NO.59, AKEJUSTREET,
              SHOMOLU, LAGOS;{" "}
            </div>
            <div>B. Your company or organisation (you or your).</div>
          </div>
        </div>
        <h1 style={{marginTop:20, marginBottom:20}} className="IntroText">Welcome to Pickorder!</h1>
        <ol>
          { termsInfo.map((r, id)=>(
		<>
		<h2>{r.header}</h2>
        
		<li className="Section">
		    <h3 className="SectionTitle"><span>{number(id)}</span> {r.title}</h3>
            {r.content.map((data)=>(
			<p className="SectionParagraph">
             {data}
            </p>))}
          </li>
		  </>
		  ))}
        </ol>
      </div>
    </Container>
  );
}

export default Terms;
